import { defineComponent as _defineComponent } from 'vue'
import { InviteLinks } from '@busy-human/opt-library';
import { DataInstance } from '@busy-human/gearbox';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { createInviteLink } from '@/util/functions';

import InviteType from '@/components/new-invite/invite-type.vue';
import InviteName from '@/components/new-invite/invite-name.vue';
import InviteRate from '@/components/new-invite/invite-rate.vue';
import InviteNote from '@/components/new-invite/invite-note.vue';
import InviteLocation from '@/components/new-invite/invite-location.vue';
import InviteContact from '@/components/new-invite/invite-contact.vue';
import InvitePrice from '@/components/new-invite/invite-price.vue';
import InviteCreate from '@/components/new-invite/invite-create.vue';
import InviteSend from '@/components/new-invite/invite-send.vue';

import { httpsCallable } from 'firebase/functions';
import { functions } from '@/util/firebase';
import Toast from "@/components/toast.vue"
import { useUserspace } from '@/store/userspace';

enum InviteStage { 
    TYPE = 0,
    NAME = 1,
    RATE = 2,
    NOTE = 3,
    LOCATION = 4,
    CONTACT = 5,
    // PRICE = 6,
    CREATE = 7,
    // SEND = 8
}


export default /*#__PURE__*/_defineComponent({
  __name: 'new-invite',
  setup(__props, { expose }) {
  expose();

const stage = ref(InviteStage.NAME);
const invite = ref(InviteLinks.Defaults());
const inviteInstance = ref<DataInstance<InviteLinks.Model> | null>(null);
const error = ref<string | null>(null);
const showToast = ref<boolean>(false)
const isInviteMsg = ref<boolean>(false)
const inviteMessage = ref<string>("Copied Invite Link to Clipboard!")
const shareMessage = ref<string>("Copied Share Link to Clipboard!")

const publishInvite = async () => {
    // console.log("Publishing invite!")
    // setTimeout(() => inviteInstance.value = {
    //     ... invite.value,
    //     link: "https://app.optme.com/mtginvite/>bk=u42553irhtwo-ref_234",
    //     $id: '-1'
    // }, 2000);
    try {

        error.value = null;
        const uid = useUserspace().uid;
        const tmp = await createInviteLink({data: invite.value, uid});
        inviteInstance.value = tmp.data;
    } catch (e) {
        console.error('Error Creating Opt Invite:', e);
        error.value = "Error";
    }
}

const restart = () => {
    invite.value = InviteLinks.Defaults();
    inviteInstance.value = null;
    // stage.value = InviteStage.TYPE;
    stage.value = InviteStage.NAME;
}

const saveInvite = () => {
    if(inviteInstance.value) {
        InviteLinks.Collection.updateDoc(inviteInstance.value.$id, inviteInstance.value)
    }
}
const handleToast = (value: 'copy' | 'share') =>{
    if(value == 'share'){
        isInviteMsg.value = false
    }
    if(value == 'copy'){
        isInviteMsg.value = true
    }
    showToast.value = true;
    setTimeout(()=>{
        showToast.value = false
    },5000)
}

// watch(invite, () => {
//     console.log(invite.value);
// }, {immediate: true})

const noScroll = ref(false)

const router = useRouter();

const goTo = (route: string) =>{
    router.push(route)
}


const __returned__ = { InviteStage, stage, invite, inviteInstance, error, showToast, isInviteMsg, inviteMessage, shareMessage, publishInvite, restart, saveInvite, handleToast, noScroll, router, goTo, InviteLinks, DataInstance, ref, watch, useRouter, createInviteLink, InviteType, InviteName, InviteRate, InviteNote, InviteLocation, InviteContact, InvitePrice, InviteCreate, InviteSend, httpsCallable, functions, Toast, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})